import React from "react";
import styles from "./index.module.scss";
import classNames from "classnames";

interface AsideProps {
    visible: boolean;
    onToggle?: () => void;
    children: React.ReactChild[];
}

export default function Aside({ visible, onToggle, children }: AsideProps) {
    return (
        <div className={classNames(styles.root, { [styles.hidden]: !visible })}>
            <div className={styles.inner}>
                <div className={styles.header}>目录</div>

                <div className={styles.main}>{children}</div>
            </div>

            <button className={styles.toggleBtn} onClick={onToggle} />
            <div role="button" className={styles.mask} onClick={onToggle} />
        </div>
    );
}
